import { useEffect, useState } from 'react';
import { getLocationFromIP } from '../modules/ip';
import { dynamicPageResolver } from '../modules/dynamicPageResolver';

export const useDynamicPageContent = (pageId, keyWord, prismicPageData) => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dynamicContent, setDynamicContent] = useState(prismicPageData);

  useEffect(() => {
    getLocationFromIP()
      .then(res => {
        setLocation(res);
      })
      .catch(() => {
        setDynamicContent(prismicPageData);
        setLoading(false);
      });
  }, [prismicPageData]);

  useEffect(() => {
    if (location) {
      const content = dynamicPageResolver(location.city);
      const dynamicSliceContent = content[pageId]
        ? content[pageId][keyWord] ?? null
        : null;

      if (dynamicSliceContent) {
        const [first] = prismicPageData.body;
        first.primary = {
          ...first.primary,
          ...dynamicSliceContent,
        };

        setDynamicContent({
          ...prismicPageData,
        });

        setLoading(false);
      } else {
        setDynamicContent(prismicPageData);
        setLoading(false);
      }
    }
  }, [location]);

  return { loading, dynamicContent };
};
